module.exports = __webpack_public_path__ + "img/snapinsta.79362985.webp";